module.exports = "/_next/static/images/27722ee47cb23dde13f92a11c59b711d-pj-woman-working@0.75x.jpg";